import './vendor/jquery.flippy.js';

/* eslint-disable */
var answers = new Array();
var numbers1 = new Array();
var numbers2 = new Array();
var correctCount = 0;
var correctProblems = new Array();
var correctAnswers = new Array();
var concentrationWon = false;

var selectedProblemIndex = -1;
var selectedAnswerIndex = -1;
var selectedProblemCard = null;
var selectedAnswerCard = null;
var selectedProblem = false;
var selectedAnswer = false;
var waiting = false;
var numberOfTries = 0;
var gameId;
var gameType;

function operation(n1, n2) {
	switch(gameType) {
	case 0:return n1+n2;
	case 1:return n1-n2;
	case 2:return n1*n2;
	case 3:return n1/n2;
	}
}
function getSign(){
	switch(gameType) {
	case 0:return ' + ';
	case 1:return ' - ';
	case 2:return ' &#215; ';
	case 3:return ' &#247; ';
	}
}

function createAnswers() {
	var i, j, k;
	var n1=0, n2=0;
	var found;

	for ( i = 0; i < 4; i++ ) {
		for ( j = 0; j < 4; j++ ) {
			// addition and multiplication
			if (gameType == 0 || gameType == 2) {
				n1 = Math.floor(Math.random() * 11 + 2 );
				n2 = Math.floor(Math.random() * 11 + 2 );
				while ( true ) {
					found = false;
					for ( k = 0; k < i*4+j; k++ ) {
						if (answers[k] == (operation(n1, n2)) ) {
							found = true;
							n1 = Math.floor(Math.random() * 11 + 2 );
							n2 = Math.floor(Math.random() * 11 + 2 );
							break;
						}
					}
					if ( found == false ) {
						answers[i*4+j] = (operation(n1, n2));
						numbers1[i*4+j] = n1;
						numbers2[i*4+j] = n2;
						break;
					}
				}
				answers[i*4+j] = (operation(n1, n2));
			}
			else if (gameType == 1) { // subtraction
				var min = 2;
				n1 = Math.floor(min + Math.random()*(2*12 - min + 1));
				n2 = Math.floor(min + Math.random()*(12 - min + 1));
				while (n1 <= n2) {
					n1 = Math.floor(min + Math.random()*(2*12 - min + 1));
					n2 = Math.floor(min + Math.random()*(12 - min + 1));
				}
				answers[i*4+j] = (operation(n1, n2));
				numbers1[i*4+j] = n1;
				numbers2[i*4+j] = n2;
			}
			else if (gameType == 3) { // division
				n1 = Math.floor(Math.random() * 11 + 2 );
				n2 = Math.floor(Math.random() * 11 + 2 );
				while (n2 == 0) {
					n2 = Math.floor(Math.random() * 11 + 2 );
				}
				n1 = n1*n2;
				var count = 0;
				while (count < 10000) {
					found = false;
					for ( k = 0; k < i*4+j; k++ ) {
						if (answers[k] == (operation(n1, n2)) ) {
							found = true;
							n1 = Math.floor(Math.random() * 11 + 2 );
							n2 = Math.floor(Math.random() * 11 + 2 );
							while (n2 == 0) {
								n2 = Math.floor(Math.random() * 11 + 2 );
							}
							n1 = n1*n2;
							break;
						}
					}
					if (found == false) {
						answers[i*4+j] = (operation(n1, n2));
						numbers1[i*4+j] = n1;
						numbers2[i*4+j] = n2;
						break;
					}
					count++;
				}
				answers[i*4+j] = (operation(n1, n2));
				numbers1[i*4+j] = n1;
				numbers2[i*4+j] = n2;

				console.log(n1 + " " + n2 + " " + answers[i*4+j]);
			}
		}
	}
	answers = shuffleArray(answers);

	for ( i = 0; i < 16; i++ ) {
		//rightButtons[i].setAnswer(answers[i]);
	}

	for ( i = 0; i < 16; i++ ) {
		correctProblems[i] = false;
		correctAnswers[i] = false;
		//console.log(numbers1[i] + " " + numbers2[i] + " " + answers[i]);
	}
}

function shuffleArray(array) {
	for (var i = array.length - 1; i > 0; i--) {
		var j = Math.floor(Math.random() * (i + 1));
		var temp = array[i];
		array[i] = array[j];
		array[j] = temp;
	}
	return array;
}


function newGame() {
	gameId = Math.random();
	numberOfTries = 0;
	correctCount = 0;
	selectedProblemIndex = -1;
	selectedAnswerIndex = -1;
	selectedProblem = false;
	selectedAnswer = false;
	createAnswers();
	$('#message').html('New game started!');
	$('#message').css('background','#FFF');
	$('.numberOfTries').html(numberOfTries);
	$('.conc_button').flippy({
		//color_target: "lightgray",
		duration: "500",
		depth: 0,
		verso: '<span class=""></span>',
		onFinish: function() {
			$(this).css('class','conc_button');
		}
	});
	//$('#gameCompleteModal').modal('show');
}

function submitHighScore() {
	//numberOfTries = 50;
	var c = gameId*numberOfTries;
	$.post("/hscores/mathMemory.jsp",
			{ GameId: gameId,
		GameType: gameType,
		Score: numberOfTries,
		Code: c,
		Age: $('#age').val(),
		Initials: $('#initials').val(),
		Location: $('#location').val() },
		function(data) {
			var tmp = eval("(" + data + ")");
			// success
			if (tmp.rank) {
				$('.rank').html(tmp.rank);
				$('.rankText').show();
			}
			else {
				$('.rankText').hide();
			}
			$('#gameCompleteModal').modal('hide');
			$('#highScoreTable tr').not(function(){if ($(this).has('th').length){return true;}}).remove();
			var tableText = '';
			var scores = tmp.scores;
			for (var i = 0; i < scores.length; i++) {
				tableText += '<tr>';
				var score = scores[i];
				tableText += '<td>' + score.r + '</td>';
				tableText += '<td>' + score.i + '</td>';
				tableText += '<td>' + score.s + '</td>';
				tableText += '<td>' + score.a + '</td>';
				tableText += '<td>' + score.l + '</td>';
				tableText += '</tr>';
			}
			$('#highScoreTable').append(tableText);
			$('#highScoreModal').modal('show');
		})
		.fail(function(data) {
			alert( "error" );
		})
		.always(function() {
			//alert("finished");
		}, "json");
}

$(document).ready(function() {
    gameType = $('.gametype').data('value');

    $('.restart').click(function(){
        newGame();
    });

    $('.conc_button').hover(function(){
        $(this).css("border-color","blue");
    },function(){
        $(this).css("border-color","black");
    });

    $('.conc_button').click(function(e){
      var el = $(e).target;
    	if (correctCount == 16) {
    		return;
    	}
      if (waiting == true) {
          return;
      }
      var thisid = $(this).attr('id');
      var bb = thisid.match(/\d+/g);
      var thisidno = parseInt(bb);
      var text;
      if (thisid.charAt(0) == 'q') {
      	if (selectedProblem == true) {
      		return;
      	}
      	if (correctProblems[thisidno] == true) {
      		return;
      	}
          text = numbers1[thisidno] + getSign() + numbers2[thisidno];
          selectedProblemIndex = thisidno;
          selectedProblemCard = $(this);
          selectedProblem = true;
          $('#instructions').html("Select a problem in Board 2.");
      }
      else if (thisid.charAt(0) == 'a') {
      	if (selectedProblem == false || selectedAnswer == true) {
      		return;
      	}
          if (correctAnswers[thisidno] == true) {
              return;
          }
          text = answers[thisidno];
          selectedAnswerIndex = thisidno;
          selectedAnswerCard = $(this);
          selectedAnswer = true;
      }
      waiting = true;
      $(this).flippy({
          color_target: "#F2F3F5",
          duration: "500",
          depth: 0,
          verso: text,
          onFinish: function() {
            waiting = false;
          	if (selectedProblem == true && selectedAnswer == false) {
          		return;
          	}
          	var n1 = numbers1[selectedProblemIndex];
          	var n2 = numbers2[selectedProblemIndex]
          	var ans = answers[selectedAnswerIndex];
          	if (operation(n1, n2) == ans) {
          		var messageString = "Correct! " + n1 + getSign() + n2 + " = " + ans;
          		$('#message').css('background','#ADEAAE');
          		$('#message').html(messageString);
                  selectedProblemCard.css('background',"#A0A1A3")
                  selectedAnswerCard.css('background',"#A0A1A3")
                  correctProblems[selectedProblemIndex] = true;
                  correctAnswers[selectedAnswerIndex] = true;
                  correctCount++;
          	}
          	else {
                selectedProblemCard.flippyReverse();
                selectedAnswerCard.flippyReverse();
                var messageString = "Sorry. Try again.";
                $('#message').html(messageString);
                $('#message').css('background','#EAADC3');
          	}
              selectedProblemIndex = -1;
              selectedAnswerIndex = -1;
              numberOfTries++;

              $('.numberOfTries').html(numberOfTries);
              if (correctCount < 16) {
                  $('#instructions').html("Select a problem in Board 1.");
              }
              else {
                  $('#gameCompleteModal').modal('show');
              }

              selectedProblem = false;
              selectedAnswer = false;
          }
      });
    });
    newGame();
});



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/math-memory/memory-games.js
 **/